/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_4_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A workbook can calculate the right total while still losing an important presentation detail. Compare chart categories, axis labels, legend entries and the data range. For PivotTables, compare the source data, filters, subtotals and grand total. A working screenshot is a reference, not a guarantee that every imported Excel chart will look the same.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_4_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即使合计正确，工作簿也可能丢失重要的展示细节。检查图表分类、轴标签、图例与数据范围；数据透视表则核对源数据、筛选、小计和总计。示例截图只是参考，不代表所有导入的 Excel 图表都能一致呈现。`)
};

/**
* | output |
* | --- |
* | "A workbook can calculate the right total while still losing an important presentation detail. Compare chart categories, axis labels, legend entries and the d..." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_4_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_4_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_4_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_4_paragraphs_0 as "gc.search_guides.gridcraft_excel_compatibility.sections.4.paragraphs.0" }